// ############# GLOBAL FUNCTIONS: ##############

// RESIZE HANDLER:
function resizeHandler() {
  console.log("window resized");
  /*
  if ($(window).width() < 767) {
    console.log("window small than 600");
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
  */
}


// SWITCH PDP CONTENT BY VARIANT
function variantContentSwitch(variantID) {
  //console.log("variantContentSwitch CALLED");
  //console.log("current variantid = " + variantID);
  $('*[data-variant-switch="group"]').each(function() {
    $( this ).find('*[data-variant-switch="single"][data-variant-id="' + variantID +'"').addClass('active').siblings('*[data-variant-switch="single"]').removeClass('active');
  });
}


// PDP IMAGE ZOOMS
function pdpImageZoom(){
  console.log("pdp image zoom");
  if ($(window).width() < 768) {
  // 1. destroy any desktop image zoom instances
  // TODO: 2. init mobile pinch zoom functionality
    $('.pdp-hero .js-slider-primary .single-photo .image-fit-wrap').each(function() {
      $(this).trigger('zoom.destroy');

    });
    
    document.querySelectorAll('.pdp-hero .js-slider-primary .single-photo .image-fit-wrap').forEach( function( el ) {
      	let sliderHeight = document.querySelector(".pdp-hero .js-slider-primary").clientWidth;
      	el.parentNode.style.height = `${sliderHeight}px`;
      	new PinchZoom.default(el, {
          draggableUnzoomed : false
        });
    })
  } 
  else {
    // TODO: 1. destroy any mobile pinch zoom instances
  // 2. init desktop image click-to-zoom functionality -- extends Zoom 1.7.21 (vendor.js)
    $('.pdp-hero .js-slider-primary .single-photo .image-fit-wrap').each(function() {
      $(this).zoom({
        on: 'click',
        magnify:1.25,
        touch:true
      });
    });
  }
}

// PRODUCT GRID ITEMS: EXPLICIT PRICE DISPLAY
function productGridItemPrice(el) {
  var selected = $(el).find(':selected');
  var variantPrice = selected.data('variant-price');
  var variantPriceCompare = selected.data('variant-price-compare');

 //console.log('variantPrice = ' + variantPrice);
  //console.log('variantPriceCompare = ' + variantPriceCompare);
  $(el).find('.js_product-price').html('$' + variantPrice);
  if (variantPrice < variantPriceCompare) {
  	// on sale, show compare price as well
      $(el).find('.js_product-price').addClass('sale');
      $(el).find('.js_product-price-compare').html('$' + variantPriceCompare);
  } else {
    // not on sale
      $(el).find('.js_product-price').removeClass('sale');
      $(el).find('.js_product-price-compare').html('');
  }
}


// ############# DOC READY! ##############
$(document).ready(function() {
  // CALL RESIZE HANDLER:
  resizeHandler();

  // lazy loading init 
  var lazyLoadInstance = new LazyLoad({
    data_src: 'lazy-src',
    data_bg: 'lazy-bg'
  });

  //AOS INIT:
  AOS.init();
  
  
  // MATCH HEIGHT MANUAL INITS:
  $(function() {
      $('.article-grid-item').matchHeight();
//      $('.product-grid-item').matchHeight();

      // accordion carousels on purpose page
      $('#superfoods-with-purpose-navitas-organics .tab-title').matchHeight();

      //builder-team-meet
      $('.team-meet-match').matchHeight();
      // builder-squares
     $('.js-square').matchHeight();
    
      // article carousel
     $('.js-article-product-carousel .product-grid-item').matchHeight();
    
    // featured article columns
    $('.feat-col').matchHeight();
     // builder-accordion-blocks 
     //$('.js-accordion-block').matchHeight();
  });

  
// PLYR INIT:
  // $( '.videoplayer' ).each( function() {
  //   const player = new Plyr(this, {
  //     hideControls: true,
  //   }); 
  // });
  

// OPEN EXTERNAL LINKS IN NEW WINDOW:
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].hostname !== "navitasorganics.zendesk.com" && links[i].href !== "javascript:void(0);" ) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
      links[i].innerHTML = links[i].innerHTML + "<span class='visuallyhidden'>&nbsp;(Opens in a new window)</span>";
    }
  }
  
    
// SMOOTH SCROLL TO ANCHOR LINKS:
//  var scroll = new SmoothScroll('a[href*="#"]');
 
  
// HAMBURGER ANIMATION:
  $( ".hamburger, .hamburger-close" ).click(function() {
    $( this ).parent('.hamburger-wrap').toggleClass( "is-active" );
    $('.mobile-nav').toggleClass('open');
    if ($('.hamburger-wrap').hasClass('is-active')) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', '');
    }
  });

  
// TOGGLE BODY CLASS ON NAV OPEN:
  $( ".js-nav-control" ).click(function() {
      $('body').toggleClass('open');
  });

  

  
// MAIN NAV
  var submenuIndex, submenuActiveItem;
  var submenuActive = false;
  //$('nav .parent li.has-children a, .js-desktop-submenu-wrapper').hover(
  $('nav ul.parent li.has-children').on('mouseenter', function(e) {
    if (submenuActive){
      $('.active-megamenu').removeClass('active-megamenu');
      $(this).removeClass('active-parent');
    }
    submenuActive = true;
    $(this).children('.js-mega-menu').addClass('active-megamenu');
    $('#nav-overlay').addClass('active-overlay');
    $(this).addClass('active-parent');
  });
  $('header').on('mouseleave', function(e) {
    if (submenuActive){
      $('.active-megamenu').removeClass('active-megamenu');
      $('#nav-overlay').removeClass('active-overlay');
      $('.active-parent').removeClass('active-parent');
      submenuActive = false;
    }
  });

  
  
// MOBILE NAV
  $('body').on('click', '.mobile-submenu-header', function() {
    if ($(window).width() < 767) {
      // $(this).next().slideToggle(200);
      $(this).toggleClass("expanded");
      $(this).parent().toggleClass("expanded");
    }
  });

  

// SEARCH 
  $('.search-close').on("click", function(e) {
    e.preventDefault();
    $('#search-pop').hide();
  });
  $("body").on("click", '.js-show-search', function(e) {
    if($('#search-pop').is(":visible")) {
      $('#search-pop').hide();
    } else {
      $('#search-pop').fadeToggle('fast').find('input').focus();
      e.stopPropagation();
      e.preventDefault();
    }
  }); 

  
// QTY ADJUST
  jQuery(function(){
    var j = jQuery; 
    var addInput = '.js-qty-wrap'; 

    j(addInput).each(function() { 
      var inputEl = j(this).closest(addInput).find('input');
      var n = inputEl.val(); 
      var plusEl = j(this).closest(addInput).find('.plus');
      var minEl = j(this).closest(addInput).find('.min');
      //On plus click add 1 to n
      plusEl.on('click', function(){
        inputEl.val(++n);
      });
      //On min click 
      minEl.on('click', function(){
      //If n is bigger or equal to 1 subtract 1 from n 
        if ( ( inputEl.val() ) > 1) {
          inputEl.val(--n);
        } 
      });
    });
  });

  
// ***** SLICK SLIDERS: ***** 
  
  // GENERIC SLICK SLIDER:
  $( '.js-component-carousel').each(function() {
    $( this ).slick( {
      slidesToShow: 3,
      slidesToScroll: 3,
      dots:true,
      arrows: true,
      prevArrow: "<a href='#' aria-label='Previous slide' class='previous-arrow' role='button'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/arrow-shadow-prev.svg'></a>",
      nextArrow: "<a href='#' aria-label='Next slide' class='next-arrow' role='button'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/next-shadow-arrow.svg'></a>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          centerMode: true,
          centerPadding: '60px',
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });

  // COLLECTION DISPLAY ON UK PAGE
  $( '.js-collection-display').each(function() {
    $( this ).slick( {
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      arrows: true,
      prevArrow: "<a href='#' aria-label='Previous slide' class='previous-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/arrow-shadow-prev.svg'></a>",
      nextArrow: "<a href='#' aria-label='Next slide' class='next-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/next-shadow-arrow.svg'></a>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  });

  // ACCOUNCEMENT BAR:
    $('.js-announcement-bar').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite:true,
      autoplay:true,
      arrows: true,
      prevArrow: "<a href='#' class='previous-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/prev.svg' alt='Next symbol'><span class='visuallyhidden'>Previous slide</span></a>",
      nextArrow: "<a href='#' class='next-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/next.svg' alt='Next symbol'><span class='visuallyhidden'>Next slide</span></a>",
    });
  // adding pause + play button
  $('#js-pause').click(function() {
    if ( $(this).hasClass('paused') ) {
      $('.js-announcement-bar').slick('slickPlay');
      $(this).removeClass('paused');
    } else {
      $('.js-announcement-bar').slick('slickPause');
      $(this).addClass('paused');
    }
  });
  
  var announcementSlideCount = $(".js-announcement-bar").slick("getSlick").slideCount;
  console.log(announcementSlideCount);
  
  if (announcementSlideCount > 1 ) {
    $('#js-pause').removeClass('visuallyhidden');
  } 

  // REVIEWS:
    $('.js-review-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite:false,
      autoplay:false,
      arrows: true,
      prevArrow: "<a href='#' class='previous-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/right-arrow.svg' alt='Next symbol'><span class='visuallyhidden'>Previous slide</span></a>",
      nextArrow: "<a href='#' class='next-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/arrow-next.svg' alt='Next symbol'><span class='visuallyhidden'>Next slide</span></a>",
    });
  
  // POST FEED:
    $( '.js-post-feed' ).each( function() {
      $( this ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite:true,
        autoplay:false,
        arrows: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots:true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              padding:0,
//              centerMode:true,
              dots:true,
              slidesToScroll: 1,
            }
          }
        ]
      });
    });

  // BLOG CAROUSEL
    $('.js-blog-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          centerMode: true,
          centerPadding: '60px',
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows:false,
          }
        }
      ]
    });

  // PDP CAROUSEL WITH THUMBS
    $('.js-slider-primary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite:true,
      asNavFor: '.js-slider-thumbs'
    });

    $('.js-slider-thumbs').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-slider-primary',
      dots: false,
      // adaptiveHeight: true,
      centerMode: false,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      vertical: true,
      draggable: true,
      focusOnSelect: true,
      useTransform: true,
      infinite: true,
      // variableWidth: true,
      arrows: true,
      prevArrow: "<a href='#' aria-label='Next slide' class='next-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/up.svg'></a>",
      nextArrow: "<a href='#' aria-label='Previous slide' class='previous-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/down.svg'></a>",
      responsive: [     
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            arrows: false,
            vertical:false,
            adaptiveHeight: false,
            useTransform:false,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            arrows: false,
            vertical:false,
            focusOnSelect: true,
            adaptiveHeight: false,
            useTransform:false,
            slidesToScroll: 1,
          }
        }
      ]
    });
    var $videoActive = false;
    $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide){
      if ( $('.js-slider-primary .slick-slide').eq(currentSlide).hasClass('product-single__video') ) {
        $(this).find('video').get(0).play();
        $videoActive = true;
      } else if($videoActive) {
        $('.js-slider-primary .product-single__video').each(function(){
          $(this).find('video').get(0).pause();
        });
        $videoActive = false;
      }
    });


    $('.js-article-product-carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      adaptiveHeight: true,
      centerMode: false,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      vertical:true,
      focusOnSelect: true,
      useTransform:true,
      infinite:false,
//      variableWidth: true,
      arrows: false,
      responsive: [     
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              cssEase: '',
              dots: true,
              vertical:false,
              adaptiveHeight: false,
              focusOnSelect: false,
              useTransform:false,
              infinite:false,
              useTransform:false,
              variableWidth: false,
            }
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots:true,
              centerMode: true,
              draggable:true,
              vertical:false,
              adaptiveHeight: false,
              focusOnSelect: false,
              useTransform:false,
              swipe:true,
              infinite:false,
              useTransform:false,
              variableWidth: false,
            }
          }
        ]
    });


    // builder-team-meet carousel
    $( '.js-meet-the-team' ).each( function() {
      $( this ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        draggable:true,
        infinite:true,
        adaptiveHeight:true,
        autoplay:false,
        arrows: true,
        prevArrow: "<a href='#' aria-label='Previous slide' class='previous-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/arrow-shadow-prev.svg'></a>",
        nextArrow: "<a href='#' aria-label='Next slide' class='next-arrow'><img src='https://cdn.shopify.com/s/files/1/0012/0605/9079/t/62/assets/next-shadow-arrow.svg'></a>",
        responsive: [     
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                dots:true,
                arrows:false,
              }
            }
          ]
      });
    });

    // MAKING ARROWS DO THINGS (opacity stuff)
    // NVM ARROWS ALREADY HAVE CLASSES AUTOMATICALLY ADDED TO USE
    /*$('.js-review-slider .prev-arrow').css('opacity', '0.2');
    $('.js-review-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      var firstSlide = $(this).find('.slick-slide:first-child');
      var lastSlide = $('.js-review-slider .slick-slide:last-child');
      if (lastSlide.hasClass('slick-current')) {
        $(this).find('.next-arrow').css('opacity', '0.2');
        $(this).find('.prev-arrow').css('opacity', '1');
        console.log('Go robot');
      } else if (firstSlide.hasClass('slick-current')) {
        $(this).find('.next-arrow').css('opacity', '1');
        $(this).find('.prev-arrow').css('opacity', '0.2');
        console.log('taemin');
      } else if ( !firstSlide.hasClass('slick-current') && !lastSlide.hasClass('slick-current') ) {
        console.log('treasure');
        $(this).find('.next-arrow').css('opacity', '1');
        $(this).find('.prev-arrow').css('opacity', '1');
      }
    });*/



// PDP IMAGES ZOOM
   if( $('.pdp-hero').length ) {
     pdpImageZoom();
  }
  
// PRODUCT GRID ITEMS: EXPLICIT PRICE DISPLAY
  if( $('.product-grid-item').length ) { 
      $('.js_product-grid-select').on('change', function() {
      var parent = $(this).closest('.js_product-grid-form');
      productGridItemPrice(parent);
    });

    $('.js_product-grid-select').each(function() { 
      var parent = $(this).closest('.js_product-grid-form');
      productGridItemPrice(parent);
    });  
  }


  
// CHANGE IMAGE, PRICE, CONTENT WITH VARIANT CHANGE
  $('.js_variant-select').on('change', function() {
    var selected = $(this).find(':selected');
    var variantID = selected.data('variant-id');
    var variantPrice = selected.data('variant-price');
    var variantPriceCompare = selected.data('variant-price-compare');
    var variantImage = selected.data('variant-image');
    var variantAvailable = selected.data('available');
    /*
    console.log("js_variant-select CHANGED");
    console.log("the new variant ID = " + variantID);
    console.log("the new variant price = " + variantPrice);
    console.log("the new variant compare price = " + variantPriceCompare);
    console.log("the new variant image id = " + variantImage);  
    */
    // ### update price based on selected:
    $('#productPrice').text(variantPrice);
    // ### update compare price based on selected, but only show if it's greater than normal price:
    if (variantPriceCompare > variantPrice) {
      $('#saleCompare').text(variantPriceCompare);
    } else {
      $('#saleCompare').text('');
    }
    // ### update availability based on selected:
    if (variantAvailable) {
      $('.js-go-cart-add-to-cart').removeAttr('disabled');
      $('.js-go-cart-add-to-cart').find('span').text('Add to Cart');

    } else {
      $('.js-go-cart-add-to-cart').attr('disabled', 'disabled');
      $('.js-go-cart-add-to-cart').find('span').text('Out of Stock');
    }
    // ### update image sliders based on selected:
    var position = -1;
    $('.single-product-photo .single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });      
    $('.product-thumbs .single-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });  
    if ( position != -1 ) { 
      $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
    }
    // ### update variant-specific content based on selected:
    variantContentSwitch(variantID);
    
    // ### reinit product image zooms:
    pdpImageZoom();

  });



// ############# END DOC READY! ##############
});
// ############# END DOC READY! ##############


// ############# RESIZE EVENT: ##############
$(window).resize(resizeHandler);


setTimeout ( function () {
  var position = $('header').outerHeight();
  var vHeight = '100vh';
  $('#menu').css('top', position);
  $('#menu').css("height", 'calc(100% - ' + position + "px)"); 
}, 1);